import { render } from "./LinkCheckTool.vue?vue&type=template&id=2edc8278&scoped=true"
import script from "./LinkCheckTool.vue?vue&type=script&lang=js"
export * from "./LinkCheckTool.vue?vue&type=script&lang=js"

import "./LinkCheckTool.vue?vue&type=style&index=0&id=2edc8278&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edc8278"]])

export default __exports__